class MailingList extends HTMLElement {
  constructor() {
    super();
    this.backdrop = this.closest('popup-panel').parentNode.querySelector('.popup-panel-backdrop');

    this.visits = this.dataset.visits;

    this.initCookies();
    this.managePopupDisplay();
    this.setupFormSubmissionHandler();
  }

  initCookies() {
    const timesVisited = this.getCookie('visits');
    const isSubscribed = this.getCookie('isSubscribed') === '1';

    if (!isSubscribed && timesVisited && timesVisited !== 'shown') {
      const incrementedVisits = parseInt(timesVisited) + 1;
      if (incrementedVisits >= this.visits) {
        this.parentNode.show();
        this.setCookie('visits', 'shown', 365);
      } else {
        this.setCookie('visits', incrementedVisits, 365);
      }
    } else if (!timesVisited) {
      this.setCookie('visits', 1, 365);
    }
  }

  managePopupDisplay() {
    this.querySelector('[close]').addEventListener('click', (ev) => {
      this.setCookie('visits', 'shown', 365);
    });

    this.backdrop.addEventListener('click', (ev) => {
      this.setCookie('visits', 'shown', 365);
    });

    this.addEventListener('custom:escape', (ev) => {
      this.setCookie('visits', 'shown', 365);
    });
  }

  setupFormSubmissionHandler() {
    this.querySelector('form').addEventListener('submit', (ev) => {
      ev.preventDefault();
      this.setCookie('visits', 'shown', 365);
    });
  }

  getCookie(name) {
    const cookieArray = document.cookie.split(';');
    for (let i = 0; i < cookieArray.length; i++) {
      const cookiePair = cookieArray[i].split('=');
      if (name === cookiePair[0].trim()) {
        return decodeURIComponent(cookiePair[1]);
      }
    }
    return null;
  }

  setCookie(name, value, days) {
    let expires = '';
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = `${name}=${value || ''}${expires}; path=/`;
  }
}

customElements.define('mailing-list', MailingList);
